.progressBarFill {
  border-radius: 4px;
  background: var(--color-tertiary-700);
  transition: width 0.5s ease-in-out;
}

.progressBarWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  progress {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
  }

  progress,
  progress::-webkit-progress-bar {
    width: 100%;
    height: 6px;
    border-radius: 4px;
    background: var(--color-gray-300);
  }

  progress:not([value]) {
    position: relative;
    overflow: hidden;

    &::after {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      content: "";
      display: block;
      position: absolute;
      border-radius: 4px;
      background-color: var(--color-tertiary-700);
      animation: indeterminateAnimation 1s infinite linear;
      transform-origin: 0%;
    }
  }

  progress::-webkit-progress-value {
    .progressBarFill();
  }

  progress::-moz-progress-bar {
    .progressBarFill();
  }

  @keyframes indeterminateAnimation {
    0% {
      transform: translateX(0) scaleX(0);
    }
    40% {
      transform: translateX(0) scaleX(0.4);
    }
    100% {
      transform: translateX(100%) scaleX(0.5);
    }
  }
}
